import { isCompany, isValid } from 'kennitala-utility';
import { decodeJwt } from 'jose';
import { addErrorMessage, FormValues, isEmail, isPhoneNumber } from 'helpers';
import { UserState } from 'store/state';

export function isLogged(user: UserState) {
	const { email, exp, kennitala, phone, token } = user;
	return !!(
		phone &&
		isEmail(email) &&
		isValid(kennitala) &&
		TokenData(token) &&
		Number.isInteger(exp) &&
		exp > Date.now() / 1000
	);
}

export function TokenData(token: string) {
	try {
		return decodeJwt(token);
	} catch (ex) {
		console.info(ex);
		return false;
	}
}

export function expirationTime() {
	const date = new Date();
	date.setFullYear(date.getFullYear() + 1);
	return Math.round(date.getTime() / 1000);
}

export function validateAuthForm(formValues: FormValues) {
	const errors = {};
	const phoneOrKennitala = `${formValues['phone']}`;
	if (!isPhoneNumber(phoneOrKennitala) && !isValid(phoneOrKennitala)) {
		addErrorMessage(errors, 'phone', 'INVALID_PHONE_OR_KENNITALA');
	}
	if (!isEmail(`${formValues['email']}`)) {
		addErrorMessage(errors, 'email', 'INVALID_EMAIL');
	}
	return errors;
}

export function validateAuthEmployeeForm(formValues: any) {
	const errors = {};
	const companyKennitala = formValues['companyKennitala'];
	if (!isPhoneNumber(formValues['phone'])) {
		addErrorMessage(errors, 'phone', 'INVALID_PHONE_NUMBER');
	}
	if (!isEmail(formValues['email'])) {
		addErrorMessage(errors, 'email', 'INVALID_EMAIL');
	}
	if (!isValid(formValues['kennitala'])) {
		addErrorMessage(errors, 'kennitala', 'INVALID_KENNITALA');
	}
	if (formValues['isManualSignCompany']) {
		if (isValid(companyKennitala)) {
			if (!isCompany(companyKennitala)) {
				addErrorMessage(errors, 'companyKennitala', 'INVALID_COMPANY_KENNITALA');
			}
		} else {
			addErrorMessage(errors, 'companyKennitala', 'INVALID_KENNITALA');
		}
	}
	return errors;
}
